export default {
  searchUserState: state => state.searchUser,
}
